import React, { useEffect, useState } from 'react';
import Meet from './Meet';
import dojoStageUrl from '../assets/dojo-stage-v2.png';

const Dojo: React.FC = () => {
  const [opening, setOpening] = useState(false);
  const [entered, setEntered] = useState(false);

  useEffect(() => {
    document.title = 'DOJO — Infinity Meet';
  }, []);

  const openDoor = () => {
    if (opening) return;
    setOpening(true);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.setTimeout(() => setEntered(true), reducedMotion ? 0 : 950);
  };

  if (entered) {
    return <Meet initialRoomName="dojo" lockRoomName experience="dojo" />;
  }

  return (
    <main
      style={{
        position: 'fixed',
        inset: 0,
        display: 'grid',
        placeItems: 'center',
        overflow: 'hidden',
        background:
          `linear-gradient(180deg, rgba(4, 8, 15, 0.42), rgba(4, 8, 15, 0.82)), url(${dojoStageUrl}) center/cover no-repeat`,
        color: '#f5ead2',
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", sans-serif',
      }}
    >
      <div
        aria-hidden="true"
        style={{
          position: 'absolute',
          inset: 0,
          background:
            'radial-gradient(circle at center, rgba(119, 207, 220, 0.11), transparent 28%), radial-gradient(circle at center, transparent 0 48%, rgba(0, 0, 0, 0.28) 78%)',
          pointerEvents: 'none',
        }}
      />

      <button
        type="button"
        onClick={openDoor}
        aria-label="Ouvrir la porte du Dojo"
        style={{
          position: 'relative',
          width: 'min(48vw, 260px)',
          aspectRatio: '1',
          display: 'grid',
          placeItems: 'center',
          borderRadius: '50%',
          border: '1px solid rgba(229, 194, 126, 0.38)',
          background: opening
            ? 'rgba(9, 22, 30, 0.68)'
            : 'rgba(5, 12, 20, 0.48)',
          color: '#e5c27e',
          cursor: opening ? 'default' : 'pointer',
          boxShadow: opening
            ? '0 0 0 18px rgba(87, 184, 204, 0.05), 0 0 90px rgba(87, 184, 204, 0.42)'
            : '0 0 0 1px rgba(255,255,255,0.04) inset, 0 24px 80px rgba(0,0,0,0.48)',
          transform: opening ? 'scale(1.08)' : 'scale(1)',
          transition: 'transform 900ms cubic-bezier(0.16, 1, 0.3, 1), box-shadow 900ms ease, background 900ms ease',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <span
          aria-hidden="true"
          style={{
            fontSize: 'clamp(84px, 15vw, 144px)',
            lineHeight: 1,
            fontWeight: 300,
            textShadow: opening
              ? '0 0 38px rgba(145, 224, 237, 0.85)'
              : '0 0 22px rgba(229, 194, 126, 0.26)',
            transform: opening ? 'scale(1.08)' : 'scale(1)',
            transition: 'transform 900ms cubic-bezier(0.16, 1, 0.3, 1), text-shadow 900ms ease',
          }}
        >
          ䷇
        </span>
      </button>

      <div
        aria-live="polite"
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          bottom: 'max(7vh, env(safe-area-inset-bottom, 0px))',
          textAlign: 'center',
          letterSpacing: '0.22em',
          fontSize: '12px',
          textTransform: 'uppercase',
          color: 'rgba(245, 234, 210, 0.72)',
        }}
      >
        {opening ? 'Le cercle s’ouvre' : '䷇ · Bǐ · L’Union'}
      </div>

      <style>{`
        @media (prefers-reduced-motion: reduce) {
          button, button span { transition: none !important; }
        }
        button:focus-visible {
          outline: 2px solid #9be2ef;
          outline-offset: 8px;
        }
      `}</style>
    </main>
  );
};

export default Dojo;
